// extracted by mini-css-extract-plugin
export var errorIcon = "_pz-1";
export var nameLogo = "_pz-0";